export { TinymceComponent } from './tinymce.component';
export { YgTinymceModule } from './tinymce.module';
